import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import type { InvestorListRowContact, InvestorListRowProps } from './InvestorListRow';

function ActionProgress({ actionType }: Pick<InvestorListRowProps, 'actionType'>) {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '50%',
        width: 24,
        height: 24,
        zIndex: 1,
      }}
    >
      <CircularProgress
        size={16}
        color={actionType === 'delete' ? 'error' : actionType === 'demote' ? 'warning' : 'primary'}
      />
    </Box>
  );
}

export default function InvestorRowActions({
  contact,
  promotionStageLabel,
  demotionStageLabel,
  isInAction,
  actionType,
}: {
  contact: Pick<InvestorListRowContact, 'onPromote' | 'onDemote' | 'onDelete'>;
} & Pick<
  InvestorListRowProps,
  'promotionStageLabel' | 'demotionStageLabel' | 'isInAction' | 'actionType'
>) {
  return (
    <>
      {demotionStageLabel && contact.onDemote && (
        <Tooltip title={demotionStageLabel}>
          <IconButton
            size="small"
            onClick={contact.onDemote}
            sx={{ padding: '2px', color: Palette.default.disabledText }}
          >
            <ArrowBackIcon sx={{ fontSize: '0.875rem' }} />
          </IconButton>
        </Tooltip>
      )}
      {promotionStageLabel && contact.onPromote && (
        <Tooltip title={promotionStageLabel}>
          <IconButton
            size="small"
            onClick={contact.onPromote}
            sx={{ padding: '2px', color: Palette.default.buttonBg }}
          >
            <ArrowForwardIcon sx={{ fontSize: '0.875rem' }} />
          </IconButton>
        </Tooltip>
      )}
      {contact.onDelete && (
        <Tooltip title="Remove">
          <IconButton
            size="small"
            onClick={contact.onDelete}
            sx={{ padding: '2px', color: Palette.danger.text }}
          >
            <DeleteOutlineIcon sx={{ fontSize: '0.875rem' }} />
          </IconButton>
        </Tooltip>
      )}
      {isInAction && <ActionProgress actionType={actionType} />}
    </>
  );
}
